import { IArticleSearchResultsData, IArticleSearchResultsAction } from 'models/search/articlesearchresults';
import { IArticleListCard } from 'models/magazine/article/articlelistcard';
import { IStore } from 'redux/IStore';
import { IPage } from 'models/common';
import { IArticleCard } from 'models/magazine/article/articlecard';

/** Action Types */
export const REQUEST_START: string = 'articlessearchresults/REQUEST_START';
export const REQUEST_FAILURE: string = 'articlessearchresults/REQUEST_FAILURE';
export const GET_ARTICLES_SUCCESS: string = 'articlessearchresults/GET_ARTICLES_SUCCESS';
export const GET_ARTICLES_SUCCESS_ADDITIONAL: string = 'articlessearchresults/GET_ARTICLES_SUCCESS';
export const SET_ITEMS_PAGE: string = 'articlessearchresults/SET_ITEMS_PAGE';
export const SET_USER_ID: string = 'articlessearchresults/SET_USER_ID';
export const RESET_DATA: string = 'articlessearchresults/RESET_DATA';
export const RESET_SEARCH_DATA: string = 'articlessearchresults/RESET_SEARCH_DATA';
export const SET_KEYWORD: string = 'articlessearchresults/SET_KEYWORD';
export const RESET_FILTERS: string = 'articlessearchresults/RESET_FILTERS';
export const SET_LANGUAGE_FILTER: string = 'articlessearchresults/SET_LANGUAGE_FILTER';
export const GET_SELECTED_SEARCHED_ARTICLE_SUCCESS: string =
	'articlessearchresults/GET_SELECTED_SEARCHED_ARTICLE_SUCCESS';

/** Initial State */
const initialState: IArticleSearchResultsData = {
	items: [],
	isFetching: false,
	itemsPage: {
		currentPage: 0,
		totalPages: 0,
		totalItems: 0,
		itemsPerPage: 10,
		items: [],
	},
	userId: null,
	keyword: null,
	sortOrder: null,
	queryType: null,
	selectedSearchedArticle: null,
};

/** Reducer */
export function articleSearchResultsReducer(state = initialState, action: IArticleSearchResultsAction) {
	switch (action.type) {
		case REQUEST_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case GET_ARTICLES_SUCCESS:
			return Object.assign({}, state, {
				items: action.payload.items,
				isFetching: false,
			});

		case GET_ARTICLES_SUCCESS_ADDITIONAL:
			return Object.assign({}, state, {
				items: Array.prototype.concat.apply([], [state.items, action.payload.items]),
				itemsPage: action.payload.itemsPage,
				isFetching: false,
			});

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case SET_ITEMS_PAGE:
			return Object.assign({}, state, {
				itemsPage: action.payload.itemsPage,
			});

		case RESET_DATA:
			return Object.assign({}, state, {
				items: [],
				itemsPage: {
					currentPage: 0,
					totalPages: 0,
					totalItems: 0,
					itemsPerPage: 10,
					items: [],
				},
				userId: null,
				selectedSearchedArticle: null,
			});

		case RESET_SEARCH_DATA:
			return Object.assign({}, state, {
				items: [],
				itemsPage: {
					currentPage: 0,
					totalPages: 0,
					totalItems: 0,
					itemsPerPage: 10,
					items: [],
				},
				userId: null,
				selectedSearchedArticle: null,
				keyword: null,
				sortOrder: null,
				queryType: null,
			});

		case SET_USER_ID:
			return Object.assign({}, state, {
				userId: action.payload.userId,
			});

		case SET_KEYWORD:
			return Object.assign({}, state, {
				keyword: action.payload.keyword,
			});

		case GET_SELECTED_SEARCHED_ARTICLE_SUCCESS:
			return Object.assign({}, state, {
				selectedSearchedArticle: action.payload.selectedSearchedArticle,
				isFetching: false,
			});

		default:
			return state;
	}
}
/** Action Creator */
export function getArticleSearchResultsAll(
	isFirstLoad: boolean,
	keyword: string,
	queryType: string,
	sortOrder: string,
	lanuageKey: number,
	id?: string,
) {
	return (dispatch, getState: () => IStore) => {
		if (isFirstLoad) {
			dispatch(resetData());
		}

		dispatch(requestStart());
		let url = 'api/Article/Search';
		switch (queryType) {
			case 'search/tag/:keyword':
				url = 'api/Article/Search/Tag';
				break;

			case 'search/author/:id':
				url = 'api/Article/Search/Author/';
				break;

			case 'search/:keyword':
				url = 'api/Article/Search';
				break;

			default:
				break;
		}

		const currentPage: number = getState().articleSearchResults.itemsPage.currentPage;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = getState().articleSearchResults.itemsPage.itemsPerPage;

		let queryString = '?';
		if (keyword && keyword !== '') {
			queryString = queryString + 'keyword=' + keyword;
		}
		let idString = '';
		if (id && id !== '') {
			idString = id;
		}

		if (lanuageKey) {
			queryString = queryString + '&languageKey=' + lanuageKey;
		}

		queryString = queryString + '&CurrentPage=' + newPage;
		queryString = queryString + '&ItemsPerPage=' + itemsPerPage;

		queryString = queryString + '&sortColumn=' + sortOrder;
		return fetch(
			getState().fetchDefault.baseAPI + url + idString + queryString,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'GET',
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IPage) => {
						if (isFirstLoad) {
							dispatch(resetData());
						}
						const articleSearchResultsState: IArticleSearchResultsData = getState().articleSearchResults;
						const items: IArticleListCard[] = articleSearchResultsState.items;
						const newItems: IArticleListCard[] = res.items;
						Array.prototype.push.apply(items, newItems);
						dispatch(getArticlesSuccess(items));
						dispatch(setItemsPage(res));
						if (!url.includes('Search/Author')) {
							dispatch(setArticleSearchKeyword(keyword));
						}
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function getArticleSearchResults(isFirstLoad: boolean, keyword: string) {
	return (dispatch, getState: () => IStore) => {
		if (isFirstLoad) {
			dispatch(resetData());
		}

		dispatch(requestStart());

		const currentPage: number = getState().articleSearchResults.itemsPage.currentPage;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = getState().articleSearchResults.itemsPage.itemsPerPage;

		let queryString = '?';
		if (keyword && keyword !== '') {
			queryString = queryString + 'keyword=' + keyword;
		}
		queryString = queryString + '&CurrentPage=' + newPage;
		queryString = queryString + '&ItemsPerPage=' + itemsPerPage;

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Article/Search/Title' + queryString,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'GET',
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IPage) => {
						if (isFirstLoad) {
							dispatch(resetData());
						}
						const articleSearchResultsState: IArticleSearchResultsData = getState().articleSearchResults;
						const items: IArticleListCard[] = articleSearchResultsState.items;
						const newItems: IArticleListCard[] = res.items;
						Array.prototype.push.apply(items, newItems);
						dispatch(getArticlesSuccess(items));
						dispatch(setItemsPage(res));
						dispatch(setArticleSearchKeyword(keyword));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function getSelectedSearchedArticle(id: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Article/' + id,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'GET',
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IArticleCard) => {
						dispatch(getSelectedSearchedArticleSuccess(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function requestStart(): IArticleSearchResultsAction {
	return {
		type: REQUEST_START,
	};
}

/** Action Creator */
export function getArticlesSuccess(items: IArticleListCard[]): IArticleSearchResultsAction {
	return {
		type: GET_ARTICLES_SUCCESS,
		payload: {
			items,
		},
	};
}

/** Action Creator */
export function requestFailure(message: any): IArticleSearchResultsAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function setItemsPage(itemsPage: IPage): IArticleSearchResultsAction {
	return {
		type: SET_ITEMS_PAGE,
		payload: {
			itemsPage,
		},
	};
}

/** Action Creator */
export function resetData(): IArticleSearchResultsAction {
	return {
		type: RESET_DATA,
	};
}

/** Action Creator */
export function resetSearchData(): IArticleSearchResultsAction {
	return {
		type: RESET_SEARCH_DATA,
	};
}

/** Action Creator */
export function setUserId(userId: string): IArticleSearchResultsAction {
	return {
		type: SET_USER_ID,
		payload: {
			userId,
		},
	};
}

/** Action Creator */
export function setArticleSearchKeyword(keyword: string): IArticleSearchResultsAction {
	return {
		type: SET_KEYWORD,
		payload: {
			keyword,
		},
	};
}

/** Action Creator */
export function getSelectedSearchedArticleSuccess(selectedSearchedArticle: IArticleCard): IArticleSearchResultsAction {
	return {
		type: GET_SELECTED_SEARCHED_ARTICLE_SUCCESS,
		payload: {
			selectedSearchedArticle,
		},
	};
}
